import { put } from "../../service/api";

const UpdateInvoicePhone = async (id, phone) => {
    try {
        const response = await put(`/invoice/${id}/updatePhone`, { phone });
        return response;
    } catch (error) {
        console.error('Error UpdateInvoicePhone:', error);
        throw error;
    }
};

export default UpdateInvoicePhone;